export default {
  namespaced  : true,

  state       : {
    roomId      : null,
    threadId    : null,
    
    viewList    : [],

    // メールアドレスの認証完了時のような別ページからofficeへの介入を行う際のTMPストア
    tmpMessage  : null,

    preInsertMessages : null,

    shoudMesageRoomSofa : false,

    isEnterdMessageRoom : false,
  },

  mutations   : {
    setTmpMessage(state, value){
      state.tmpMessage = value;
    },

    setPreInsertMessages(state, value){
      state.preInsertMessages = value;
    },
    
    setRoomId(state, value){
      state.roomId = value;
    },

    setThreadId(state, value){
      state.threadId = value;
    },

    pushViewList(state, value){
      state.viewList.push(value);
    },

    disabledAllMessages(state){
      for(let i = 0; i < state.viewList.length; i++){
        state.viewList[i].isDisabled = true;
      }
    },

    clearViewList(state){
      state.viewList = [];
    },

    setShoudMesageRoomSofa(state, value){
      state.shoudMesageRoomSofa = value;
    },

    resetStore(state){
      state.roomId      = null;
      state.threadId    = null;
      state.viewList    = [];
      state.tmpMessage  = null;
    },

    setIsEnterdMessageRoom(state, value){
      state.isEnterdMessageRoom = value;
    }
  },

  actions     : {
    updateTmpMessage(context, payload){
      context.commit('setTmpMessage', payload.data);
    },

    updatePreInsertMessages(context, payload){
      context.commit('setPreInsertMessages', payload.data);
    },

    updateRoomId(context, payload){
      context.commit('setRoomId', payload.value);
    },

    updateThreadId(context, payload){
      context.commit('setThreadId', payload.value);
    },

    attachViewList(context, payload){
      context.commit('pushViewList', payload.value);
    },

    disabledAllMessages(context){
      context.commit('disabledAllMessages');
    },

    initializeRoomView(context){
      context.commit('clearViewList');
    },

    updateShouldMessageRoomSofa(context, payload){
      context.commit('setShoudMesageRoomSofa', payload.value);
    },

    resetStore(context){
      context.commit('resetStore');
    },

    updateIsEnterdMessageRoom(context, payload){
      context.commit('setIsEnterdMessageRoom', payload.value);
    }
  }
}